<template>
	<a class="google float-left flex justify-center round" alt="Sign In Using Google Auth" @click="signInWithPopUp()">
		<img :src="google_logo" width="50" alt="Google Logo">
	</a>
</template>

<script>
	
	// Import firebase services
	import firebase from 'firebase/app'
    import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

	export default {

		/*
		** Set the component name
		*/

		name: 'GoogleAuthSignInButton',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			SpinnerMethods

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			google_logo: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fgoogle-logo.svg?alt=media&token=76d68910-8e2a-4dfe-8015-7af814084341',
			google_provider: null,
			google_user: null

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			setGoogleProvider: function() {

				this.google_provider = new firebase.auth.GoogleAuthProvider();

			},

			signInWithPopUp: function() {

				// Set the provider
				this.setGoogleProvider();

				// Trigger pop up
				firebaseAuth.signInWithPopup(this.google_provider)
				.then(function(result) {

					// Store the data
					this.google_user = result.user;

				}.bind(this))
				.then(() => {

					if (this.google_user) {

						// Check if user exists
						this.userCheck();

					} else {

						// Throw error message
						this.$swal('Uh Oh!', 'Looks like we ran into the following issue when signing you in.', 'error');

					}

				})
				.catch(function(error) {

					// Throw error message
					this.$swal('Uh Oh!', 'Looks like we ran into the following issue when signing you in. More details: ' + error.message, 'error');

					// Send to bugsnag
					this.reportCustomBugsnagError({
						title: 'SISU - Google Auth Sign In With Pop Up',
						errorType: 'Firebase Auth',
						section: 'SISU',
						component: 'GoogleAuthSignInButton',
						error: error,
						custom: {
							errorCode: error.code,
							errorMessage: error.message,
							userEmail: error.email,
							credentialType: error.credential
						}
					});

				}.bind(this));

			},

			userCheck: function() {

				// Get the user doc
				usersModel.doc(this.google_user.uid).get()
				.then(doc => {

					// Log em' in
					if (doc.exists) {

						// Hide the spinner
						this.hideSpinner();

						// Redirect to For You page
						this.$router.push({ name: 'Dashboard' });

					} else {

						if (firebaseAuth.currentUser) {

							// Sign the user out
							firebaseAuth.signOut()
							.then(() => {

								// Redirect to sign up page
								this.$router.push({ name: 'SignUp' });

								// Throw error message
						    	this.$swal('Uh Oh!', 'Please create an account before signing in.', 'error');

							});

							return;

						}

						// Redirect to sign up page
						this.$router.push({ name: 'SignUp' });

						// Throw error message
				    	this.$swal('Uh Oh!', 'Please create an account before signing in.', 'error');

					};

				})
				.catch(error => {

					// Send to bugsnag
					this.reportNoAuthBugsnagError({
						title: 'SISU - Google Sign In User Check',
						errorType: 'Firestore Database',
						section: 'SISU',
						component: 'GoogleAuthSignInButton',
						error: error
					});

				});

			}

		}

	}

</script>